import * as moment from 'moment'

import { authRef, databaseRef, LocalPersistence } from 'config'

import * as mixpanel from 'mixpanel-browser'
import SnackbarService from 'services/snackbars'
import { action } from '../../dispatchAction'
import { insertNewValue } from '../insertNewValue'
import { USER_ACTION_TYPES } from '../types'

const userSetup = (
  userId: string,
  userData: any,
  userDataToSave: any,
  usersTableData: {
    email: any
    full_name: any
    role: string
    avatar_url: any
    parental_instructions_complete: boolean
  },
  response,
  dispatch,
  successCallback: (data: any) => void
) => {
  window.localStorage.setItem('userId', userId)

  // !mixpanel stuff needed to be separated into appropriate action
  mixpanel.alias(userId)
  mixpanel.get_distinct_id()
  mixpanel.people.set({
    ID: userId,
    $name: userData.full_name,
    $email: userData.email,
    $created: userDataToSave.created_at
  })

  // *should call user.identify after every `people.set`, check documentation for more details
  mixpanel.identify(userId)

  mixpanel.track('Signed up', {
    date: userDataToSave.created_at,
    role: usersTableData.role
  })
  // !end of mixpanel stuff
  dispatch(
    action(USER_ACTION_TYPES.save_user_success, {
      user: { ...usersTableData }
    })
  )
  dispatch(
    action(USER_ACTION_TYPES.signup_success, {
      userData: { ...usersTableData },
      // userAuth: {...response.user},
      userAuth: {
        uid: response.user?.uid,
        displayName: response.user?.displayName,
        email: response.user?.email,
        phoneNumber: response.user?.phoneNumber,
        photoURL: response.user?.photoURL,
        providerId: response.user?.providerData,
        emailVerified: response.user?.emailVerified,
        metadata: response.user?.metadata,
        isAnonymous: response.user?.isAnonymous,
        refreshToken: response.user?.refreshToken,
        isGetPhoneNumber: true
      }
    })
  )

  successCallback({
    ...usersTableData,
    userId: response.user!.uid
  })
}

export const signUp = (
  userRole: string,
  userData: any,
  successCallback: (data: any) => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async dispatch => {
  dispatch(action(USER_ACTION_TYPES.signup_begins))

  await authRef.setPersistence(LocalPersistence)

  authRef
    .createUserWithEmailAndPassword(userData.email, userData.password)
    .then(async response => {
      const userId = response.user!.uid
      const usersTableData = {
        email: userData.email,
        full_name: userData.full_name,
        role: userRole,
        avatar_url: userData.avatar_url ? userData.avatar_url : '',
        parental_instructions_complete: false
      }

      let userDataToSave: any = null
      let tableName: string = ''
      if (userRole === 'parent') {
        userDataToSave = {
          id_parent: userId,
          name: userData.full_name,
          first_name: userData.pName,
          last_name: userData.pLastName,
          phone: userData.pPhone
        }
        tableName = 'parents'
      } else if (userRole === 'careProfessional') {
        userDataToSave = {
          id_care_professional: userId,
          name: userData.full_name,
          organization: userData.organization,
          profession: userData.profession,
          title: userData.title,
          phone: userData.cPhone
        }
        tableName = 'care_professionals'
      } else if (userRole === 'educator') {
        userDataToSave = {
          id_educator: userId,
          name: userData.full_name,
          first_name: userData.pName,
          last_name: userData.pLastName,
          phone: userData.pPhone
        }
        tableName = 'educators'
      }

      userDataToSave = {
        ...userDataToSave,
        email: userData.email,
        created_at: moment().unix(),
        updated_at: moment().unix(),
        enabled: true
      }

      // update display name of auth user
      if (!response.user?.displayName && userData.full_name) {
        await response.user?.updateProfile({ displayName: userData.full_name })
      }

      insertNewValue(userId, usersTableData, 'users')
        .then(() => {
          if (tableName !== 'educators') {
            databaseRef
              .child(tableName)
              .child(userId)
              .set(userDataToSave)
              .then(() => {
                userSetup(
                  userId,
                  userData,
                  userDataToSave,
                  usersTableData,
                  response,
                  dispatch,
                  successCallback
                )
              })
              .catch(error => {
                SnackbarService.showSnackbar(
                  'Sorry, something went wrong (Error 7), Please contact support@giantleap.tech',
                  'error'
                )
                const { code, message } = error
                dispatch(
                  action(USER_ACTION_TYPES.signup_error, { code, message })
                )
                errorCallback(message)
              })
          } else {
            userSetup(
              userId,
              userData,
              userDataToSave,
              usersTableData,
              response,
              dispatch,
              successCallback
            )
          }
        })
        .catch(error => {
          const { message } = error
          SnackbarService.showSnackbar(
            'Sorry, something went wrong (Error 6), Please contact support@giantleap.tech',
            'error'
          )
          errorCallback(message)
        })
    })
    .catch(error => {
      const { code, message } = error
      SnackbarService.showSnackbar(
        'Sorry, something went wrong (Error 8), Please contact support@giantleap.tech',
        'error'
      )
      dispatch(action(USER_ACTION_TYPES.signup_error, { code, message }))
      errorCallback(message)
    })
}



// WEBPACK FOOTER //
// ./src/store/user/actions/signUp.action.ts